import React from 'react'

import { LineItemTotals } from '../../../models/line-item'
import { useRegisterManager } from '../../../ng-compat/hooks'
import { useFormatNumber } from '../../helpers/formatNumberHooks'

interface Props {
  totals: LineItemTotals
}

export const LineItemTotalBasePrice: React.FC<Props> = ({ totals }) => {
  const formatNumber = useFormatNumber()
  const registerManager = useRegisterManager()
  const totalBasePrice = registerManager.isTaxInclusive()
    ? totals.inclusiveBasePrice
    : totals.exclusiveBasePrice
  return <>{formatNumber(totalBasePrice)}</>
}
